import * as React from 'react';
import ModalContext from './ModalContext';
import ReactModal from 'react-modal';
import styled from 'react-emotion';
import get from 'lodash.get';
const Cover = styled('div') `
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
`;
Cover.displayName = 'Cover';
const ModalRoot = () => (React.createElement(ModalContext.Consumer, null, ({ modalComponent, isOpen, modalType, hideTarget, props }) => {
    /** Do not render anything if there is no active modal */
    if (!isOpen)
        return null;
    const Component = modalComponent;
    if (Component && isOpen && modalType === 'modal') {
        /** A modal has been requested, from somewhere in the app  */
        return (React.createElement(ReactModal, { className: props.modalStyles, 
            /** isOpen should always be true here, since this is only rendered when a modal is requested */
            isOpen: true, 
            /**
             * react-modal requires an onRequestClose prop that takes a func to call when the modal is closed
             * We use this to make sure the context is updated
             */
            onRequestClose: hideTarget },
            React.createElement(Component, Object.assign({ hideTarget: hideTarget }, props))));
    }
    if (isOpen && props.showCover) {
        const coverStyles = get(props, 'coverStyles');
        /** Inject a clickable 'cover' behind flyouts */
        return React.createElement(Cover, { onClick: hideTarget, style: coverStyles });
    }
}));
export default ModalRoot;
//# sourceMappingURL=ModalRoot.js.map